/**
 * Derives up to 2 initials from a title (e.g. "Italian Classics" → "IC").
 */
export function getCollectionInitials(title: string): string {
  const words = title.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return (words[0]![0] ?? '?').toUpperCase();
  return ((words[0]![0] ?? '') + (words[words.length - 1]![0] ?? '')).toUpperCase();
}

/**
 * Derives a deterministic brand-aligned colour from a collection id.
 *
 * Hue is biased toward the brand's teal-to-amber arc (160–220° teal family,
 * wrapping around through warm amber at 20–50°) by mapping the id hash into
 * a 200° window starting at teal. Saturation and lightness are fixed at values
 * that match the brand's vibrancy without being too dark or too washed out.
 */
export function getCollectionColour(id: string): string {
  let sum = 0;
  for (let i = 0; i < id.length; i++) {
    sum += id.charCodeAt(i);
  }
  // Spread across a 200° arc anchored at teal (160°), wrapping into amber
  const hue = (160 + (sum % 200)) % 360;
  return `hsl(${hue}, 48%, 44%)`;
}
